<template>
  <div class="sections">
    <div class="container">
      <div class="row sections__items-row">

        <div class="col-12 col-xl-1-5 sections__item sections__item--Purpose text-cente"
          :class="{'sections__item--disabled': finishedSections.Purpose}">
          <div @click="goToSubject('demoPurpose', finishedSections.Purpose)"
            class="sections__img-container">
            <img class="sections__img" src="/static/img/Purpose.svg" alt="">
          </div>
          <span @click="goToSubject('demoPurpose', finishedSections.Purpose)"
            class="sections__btn">
            Purpose
          </span>
        </div>

        <div class="col-12 col-xl-1-5 sections__item sections__item--Purpose text-cente"
          :class="{'sections__item--disabled': finishedSections.Ecosystems}">
          <div @click="goToSubject('demoEcosystem', finishedSections.Ecosystems)"
            class="sections__img-container">
            <img class="sections__img" src="/static/img/Ecosystems.svg" alt="">
          </div>
          <span @click="goToSubject('demoEcosystem', finishedSections.Ecosystems)"
            class="sections__btn">
            Ecosystems
          </span>
        </div>

        <div class="col-12 col-xl-1-5 sections__item sections__item--Purpose text-cente"
          :class="{'sections__item--disabled': finishedSections.Adaptability}">
          <div @click="goToSubject('demoAdaptability', finishedSections.Adaptability)"
            class="sections__img-container">
            <img class="sections__img" src="/static/img/Adaptability.svg" alt="">
          </div>
          <span @click="goToSubject('demoAdaptability', finishedSections.Adaptability)"
            class="sections__btn">
            Adaptability
          </span>
        </div>

        <div class="col-12 col-xl-1-5 sections__item sections__item--Purpose text-cente"
          :class="{'sections__item--disabled': finishedSections.Empowerment}">
          <div @click="goToSubject('demoEmpowerment', finishedSections.Empowerment)"
            class="sections__img-container">
            <img class="sections__img" src="/static/img/Real Empowerment.svg" alt="">
          </div>
          <span @click="goToSubject('demoEmpowerment', finishedSections.Empowerment)"
            class="sections__btn">
            Real Empowerment
          </span>
        </div>

        <div class="col-12 col-xl-1-5 sections__item sections__item--Purpose text-cente"
          :class="{'sections__item--disabled': finishedSections.Leadership}">
          <div @click="goToSubject('demoLeadership', finishedSections.Leadership)"
            class="sections__img-container">
            <img class="sections__img" src="/static/img/Leadership.svg" alt="">
          </div>
          <span @click="goToSubject('demoLeadership', finishedSections.Leadership)"
            class="sections__btn">
            Leadership
          </span>
        </div>

      </div>
    </div>

    <div class="sections__dialog">
      <div class="container">
        <div class="row">

          <div v-if="finishedNumber === 0" class="col-12">
            <h1 class="sections__dialog-title">Pick where to start</h1>
            <p class="sections__dialog-text">
              Pick where you’d like to begin. You will be assessing your organisation in five areas:
              Purpose, Ecosystems, Adaptability, Real Empowerment and Leadership.
            </p>
            <img class="sections__dialog-img" src="~assets/img/evaluation-rocket.svg" alt="">
          </div>

          <div v-else-if="finishedName" class="col-12">
            <h1 class="sections__dialog-title">{{ finishedName }} Complete!</h1>
            <p class="sections__dialog-text">
              Please select next section.
            </p>
            <img class="sections__dialog-img" src="~assets/img/icon-done.svg" alt="">
          </div>

          <div v-else class="col-12">
            <h1 class="sections__dialog-title">Select next section</h1>
            <p class="sections__dialog-text">
              You will be assessing your organisation in five areas:
              Purpose, Ecosystems, Adaptability, Real Empowerment and Leadership.
            </p>
            <img class="sections__dialog-img" src="~assets/img/evaluation-rocket.svg" alt="">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// API
import demoApi from '@/api/demo';

export default {
  props: ['answers', 'finishedName'],
  data() {
    return {
      subjectsList: [],
      completedSubject: '',
    };
  },
  computed: {
    finishedSections() {
      return this.$store.state.demoSubjectFinished;
    },
    finishedNumber() {
      return this.$store.state.demoCountFinished;
    },
  },
  methods: {
    goToSubject(sectionPath, finished) {
      if (!finished) {
        this.$router.push({ name: sectionPath });
      }
    },
  },
  created() {
    if (this.finishedNumber === 5) {
      this.$router.push({ name: 'demoFinish' });
    }
    demoApi.index().then((response) => {
      this.subjectsList = response.data.traits;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Demo/Sections.vue